/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .factory('Validation', function ($q, CommonUtils) {
            var Validation = {};
            
            Validation.reset = function ($scope, name) {
                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                scopeObject[CommonUtils.getScopeName($scope, name) + 'Error'] = false;
            };

            Validation.require = function ($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.defaultValue === undefined)
                    args.defaultValue = '';

                if (args.suffix === undefined)
                    args.suffix = 'Required';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];

                var checkedIsValid = true;
                if (args.defaultValue === '') {
                    checkedIsValid = !((nameValue || args.defaultValue).trim() === args.defaultValue);
                }
                else {
                    checkedIsValid = !((nameValue || args.defaultValue) === args.defaultValue);
                }

                if (!checkedIsValid) {
                    $scope.Control.IsValid = false;
                    
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' is required'));
                }
                else {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                }

                return deferred.promise;
            };

            Validation.isNumeric = function($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];

                var regex = /^[0-9]+$/;

                var matched = (nameValue || '').trim() === '' || ((nameValue || '').match(regex) || false);
                if (matched) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                } else {
                    $scope.Control.IsValid = false;
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' does not match the given regular expression: ' + regex));
                }

                return deferred.promise;
            };

            Validation.isAlphaNumeric = function($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];

                var regex = /^[0-9a-zA-Z]+$/;

                var matched = (nameValue || '').trim() === '' || ((nameValue || '').match(regex) || false);
                if (matched) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                } else {
                    $scope.Control.IsValid = false;
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' does not match the given regular expression: ' + regex));
                }

                return deferred.promise;
            };

            Validation.isMatch = function($scope, name, regex, args) {
                var deferred = $q.defer();
                
                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)] || '';

                var reg = new RegExp(regex);
                
                var match = reg.test(nameValue);
                if (nameValue === '' || match) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                } else {
                    $scope.Control.IsValid = false;
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' does not match the given regular expression: ' + regex));
                }

                return deferred.promise;
            };

            Validation.isSame = function ($scope, name, compared, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.defaultValue === undefined)
                    args.defaultValue = '';

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];
                var comparedValue = scopeObject[CommonUtils.getScopeName($scope, compared)];

                var checkedIsValid = nameValue == comparedValue;

                if (!checkedIsValid) {
                    $scope.Control.IsValid = false;

                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' is not the same with ' + compared));
                }
                else {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                }

                return deferred.promise;
            };

            Validation.isEmail = function ($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];

                if (!LhApp.Function.String.isEmail(nameValue || '')) {
                    $scope.Control.IsValid = false;
                    
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' requires a valid email address'));
                }
                else {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                }
                
                return deferred.promise;
            };

            Validation.isSocialSecurityNumber = function ($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];
                var isValid = true;

                if (checkoutOverrides && checkoutOverrides.Profile && typeof checkoutOverrides.Profile.IsSocialSecurityNumberValidation === 'function') {
                    isValid = checkoutOverrides.Profile.IsSocialSecurityNumberValidation(nameValue);
                }

                if (isValid) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                } else {
                    $scope.Control.IsValid = false;

                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' requires a valid Social Security Number'));
                }

                return deferred.promise;
            };

            Validation.isValidPhoneLocalized = function ($scope, name, elem, type, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};

                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];

                var iti = window.intlTelInputGlobals.getInstance(elem.get(0));
                var numberType = iti.getNumberType();
                var numberTypeIsValid = false;

                var regex = /^\+{0,1}[0-9]+$/g;

                if (type == "phone") {
                    numberTypeIsValid = (numberType === intlTelInputUtils.numberType.FIXED_LINE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
                } else if (type == "mobile") {
                    numberTypeIsValid = (numberType === intlTelInputUtils.numberType.MOBILE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
                } else if (type == "both") {
                    numberTypeIsValid = (numberType === intlTelInputUtils.numberType.FIXED_LINE || numberType === intlTelInputUtils.numberType.MOBILE || numberType === intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE) ? true : false;
                }

                if ((iti.isValidNumber() && numberTypeIsValid && regex.test(nameValue)) || nameValue === '' || nameValue === undefined) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                } else {
                    $scope.Control.IsValid = false;
                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + " isn't a valid phone number"));
                }

                return deferred.promise;
            };

            Validation.isValidDateOfBirth = function ($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};
                if (args.suffix === undefined)
                    args.suffix = 'Invalid';

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];
                var parsedDate = undefined;
                var today = new Date();

                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.ParseDate === 'function') {
                    parsedDate = checkoutOverrides.Generic.ParseDate(nameValue);
                }

                var isValid = (parsedDate !== undefined) && (parsedDate <= today);

                if (isValid) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                }
                else {
                    $scope.Control.IsValid = false;

                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' requires a valid date in ' + args.format + ' format'));
                }

                return deferred.promise;
            };

            Validation.isAgeAboveThreshold = function ($scope, name, args) {
                var deferred = $q.defer();

                if (args === undefined)
                    args = {};
                if (args.suffix === undefined)
                    args.suffix = 'NotAllowed';
                if (args.age === undefined)
                    args.age = 18;

                var scopeObject = CommonUtils.getScopeObject($scope, CommonUtils.getScopePath($scope, name));
                var nameValue = scopeObject[CommonUtils.getScopeName($scope, name)];
                var dateOfBirth = undefined;
                var today = new Date();
                var latestDateOfBirth = new Date(today.getFullYear() - args.age, today.getMonth(), today.getDate());

                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.ParseDate === 'function') {
                    dateOfBirth = checkoutOverrides.Generic.ParseDate(nameValue);
                }

                var isValid = (dateOfBirth !== undefined) && (dateOfBirth <= latestDateOfBirth);

                if (isValid) {
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = false;
                    deferred.resolve(true);
                }
                else {
                    $scope.Control.IsValid = false;

                    scopeObject[CommonUtils.getScopeName($scope, name + 'Error')] = true;
                    scopeObject[CommonUtils.getScopeName($scope, name + args.suffix)] = true;
                    deferred.reject(new Error(name + ' implies that you are younger than ' + args.age + ' years old'));
                }

                return deferred.promise;
            };

            return Validation;
        });
})();
             